import { render, staticRenderFns } from "./SliderArrows.vue?vue&type=template&id=f56c14ea&"
import script from "./SliderArrows.vue?vue&type=script&lang=js&"
export * from "./SliderArrows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports